import { render, staticRenderFns } from "./CopyGlobalCof.vue?vue&type=template&id=682a1890&scoped=true&"
import script from "./CopyGlobalCof.vue?vue&type=script&lang=js&"
export * from "./CopyGlobalCof.vue?vue&type=script&lang=js&"
import style0 from "../../styles/button.less?vue&type=style&index=0&id=682a1890&lang=less&scoped=true&"
import style1 from "./CopyGlobalCof.vue?vue&type=style&index=1&id=682a1890&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682a1890",
  null
  
)

export default component.exports